import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { fetchAllRequestStatus } from 'actions/utils';
import * as actions from 'actions/vendor-request';
import { fetchChildUsers } from 'actions/users';
import { fetchPrescreenInstance } from 'actions/prescreen';
import {
  Container,
  HeadingTitle,
  FlexRow,
  HeaderFlexRow,
  PaddingWrapper,
  PlainButton,
} from 'components/styled-components';
import styled from 'styled-components';
import colors from 'utils/colors';
import { pluckFromArray } from 'utils/functions';
import {
  NonIdealState,
  Intent,
  Button,
  Checkbox,
  Tooltip,
  Position,
} from '@blueprintjs/core';
import { DialogWrapper } from 'components/DialogWrapper';
import { updateVendorRequest, renewRequest } from 'api/vendor-request';
import { AppToaster } from 'components/AppToaster';
import Loading from 'components/loading';
import VendorInfo from 'components/renewals/vendor-info';
import PrescreenInfo from 'components/renewals/prescreen-info';
import SponsorInfo from 'components/renewals/sponsor-info';
import AddContact from 'components/vendors/addContact';
import hasPermission from 'utils/hasPermission';
import Permissions from 'utils/permissions';
import { createContact } from 'api/users';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';

const ValidationSchema = Yup.object().shape({
  checked1: Yup.boolean()
    .oneOf([true])
    .required('Required'),
  checked2: Yup.boolean()
    .oneOf([true])
    .required('Required'),
  checked3: Yup.boolean()
    .oneOf([true])
    .required('Required'),
  vendorContact: Yup.array().of(Yup.object()
		.shape({
			email: Yup.string().email('Invalid Email'),
			userID: Yup.number(),
		})
	)
    .required('Required')
    .nullable(),
});

const RenewalStep = ({
  appUser,
  title,
  question,
  content,
  checkName,
  handleChange,
  checked,
  addContact,
  setFieldValue,
}) => {
  return (
    <StepBox>
      <FlexRow>
        <h1>{title}</h1>
        {addContact &&
          hasPermission(appUser.permissions, [
            Permissions.CREATE_ALL_USERS,
            Permissions.CREATE_THIRD_PARTY_USER,
          ]) && (
            <StyledContactButton>
              <AddContact
                addBtnLabel="New Third Party Contact"
                drawerLabel="Create a New Third Party Contact"
                drawerBtnLabel="SUBMIT"
                handleFormSubmit={(user, actions, close) =>
                  addContact(user, actions, close, setFieldValue)
                }
                style={{ marginRight: '1rem' }}
                className="addContactButton"
              />
            </StyledContactButton>
          )}
      </FlexRow>

      {content}
      <StepBoxBottomBar>
        <Checkbox
          large
          checked={checked}
          onChange={handleChange}
          name={checkName}
        />
        <h2>{question}</h2>
      </StepBoxBottomBar>
    </StepBox>
  );
};

class RenewalDetails extends Component {
  state = { dialogOpen: false };

  componentDidMount() {
    const { vendorRequestID } = this.props.match.params;
    this.props.fetchVendorRequest(vendorRequestID);
    this.props.fetchPrescreenInstance(vendorRequestID);
    this.props.fetchAllRequestStatus().then(() => {
      const OUTDATED_ID = pluckFromArray(
        this.props.statuses,
        'statusName',
        'Outdated Assessment'
      ).vendorRequestStatusID;
      this.setState({ OUTDATED_ID });
    });
    this.props.loaded &&
      !this.props.error.isError &&
      this.props.vendorRequest.vendorInformation &&
      this.getChildUsers(this.props.vendorRequest.vendorInformation.vendorName);
  }

  componentDidUpdate() {
    if (
      this.props.loaded &&
      !this.props.vendorsLoaded &&
      !this.props.error.isError
    ) {
      this.props.vendorRequest.vendorInformation &&
        this.getChildUsers(
          this.props.vendorRequest.vendorInformation.vendorName
        );
    }
  }

  getChildUsers = thirdPartyName => {
    this.props.fetchChildUsers({
      start: 0,
      limit: -1,
      status: 'active',
      thirdParty: thirdPartyName,
    });
  };

  handleRenew = ({ vendorContact }, actions) => {
    const { vendorRequestID } = this.props.match.params;

		const vendorC = vendorContact.map(vc => {
			return vc.userID;
		})

    renewRequest(vendorRequestID, {
      vendorContact: vendorC
    }).then(
      res => {
        AppToaster.show({
          message: res.data.message,
          intent: Intent.SUCCESS,
        });
        actions.setSubmitting(false);
        this.props.history.push('/renewals');
      },
      error => {
        AppToaster.show({
          message: error.response.data.message,
          intent: Intent.DANGER,
        });
        actions.setSubmitting(false);
      }
    );
  };

  addNewContact = (newVendor, actions, close, setFieldValue) => {
    actions.setSubmitting(true);
    const vendorID = parseInt(
      this.props.vendorRequest.vendorInformation.vendorID
    );
    createContact({ thirdPartyID: vendorID, ...newVendor })
      .then(res => {
        AppToaster.show({
          message: res.data.message,
          intent: Intent.SUCCESS,
        });
        actions.setSubmitting(false);

        close();
        setFieldValue('vendorContact', [{
          userID: res.data.userId,
          firstName: newVendor.firstName,
          lastName: newVendor.lastName,
          email: newVendor.email,
        }]);
      })
      .catch(err => {
        AppToaster.show({
          message: err.response.data.message,
          intent: Intent.DANGER,
        });
        actions.setSubmitting(false);
      });
  };

  setOutdatedStatus = () => {
    this.setState({ dialogOpen: false });
    const body = {
      vendorRequestStatus: this.state.OUTDATED_ID,
    };
    updateVendorRequest(this.props.match.params.vendorRequestID, body)
      .then(res => {
        AppToaster.show({
          // set a custom msg with renewal context instead of the generic update msg
          message: 'Successfully marked the assessment as unfit for renewal.',
          // message: res.data.message,
          intent: Intent.SUCCESS,
        });
        setTimeout(() => this.props.history.push('/renewals'), 1000);
      })
      .catch(err => {
        AppToaster.show({
          message: err.response.data.message,
          intent: Intent.DANGER,
        });
      });
  };

  render() {
    const { vendorRequest, loaded, loading, error } = this.props;

    if (loading) {
      return <Loading size={100} />;
    } else if (loaded && error.isError) {
      return (
        <Container width="50%">
          <PaddingWrapper>
            <NonIdealState
              icon="error"
              title="There was an error fetching the renewal details"
              description={error.message}
              action={
                <Button
                  text="Back to renewals"
                  onClick={() => this.props.history.push('/renewals')}
                />
              }
            />
          </PaddingWrapper>
        </Container>
      );
    } else {
      return (
        <Container>
          <Formik
            validationSchema={ValidationSchema}
            onSubmit={this.handleRenew}
            initialValues={{
              checked1: false,
              checked2: false,
              checked3: false,
              vendorContact: this.props.vendorRequest.vendorContact,
            }}
          >
            {({
              values,
              handleChange,
              isValid,
              setFieldValue,
              isSubmitting,
            }) => (
              <Form>
                <HeaderFlexRow>
                  <HeadingTitle>Renewal Details</HeadingTitle>
                  <div style={{ display: 'flex' }}>
                    {hasPermission(
                      this.props.appUser.permissions,
                      Permissions.MODIFY_ALL_THIRD_PARTY_REQUESTS
                    ) ||
                    (hasPermission(
                      this.props.appUser.permissions,
                      Permissions.MODIFY_OWNED_THIRD_PARTY_REQUESTS
                    ) &&
                      this.props.vendorRequest.sponsorInformation &&
                      this.props.vendorRequest.sponsorInformation.userID ===
                        this.props.appUser.userID) ? (
                      <PlainButton
                        disabled={!loaded}
                        className="warning"
                        type="button"
                        onClick={() => this.setState({ dialogOpen: true })}
                      >
                        UNFIT FOR RENEWAL
                      </PlainButton>
                    ) : (
                      <Tooltip
                        content={
                          <>
                            You must be the sponsor of an
                            <br />
                            assessment to change its status.
                          </>
                        }
                        position={Position.BOTTOM}
                      >
                        <PlainButton
                          disabled
                          type="button"
                          onClick={() => this.setState({ dialogOpen: true })}
                        >
                          UNFIT FOR RENEWAL
                        </PlainButton>
                      </Tooltip>
                    )}
                    {hasPermission(
                      this.props.appUser.permissions,
                      Permissions.RENEW_ALL_THIRD_PARTY_REQUESTS
                    ) ||
                    (hasPermission(
                      this.props.appUser.permissions,
                      Permissions.RENEW_OWNED_THIRD_PARTY_REQUESTS
                    ) &&
                      this.props.vendorRequest.sponsorInformation &&
                      this.props.vendorRequest.sponsorInformation.userID ===
                        this.props.appUser.userID) ? (
                      <PlainButton
                        display="flex"
                        type="submit"
                        disabled={!isValid || isSubmitting}
                      >
                        RENEW
                        {isSubmitting && (
                          <span style={{ marginLeft: '1rem' }}>
                            <Loading size={20} />
                          </span>
                        )}
                      </PlainButton>
                    ) : (
                      hasPermission(
                        this.props.appUser.permissions,
                        Permissions.RENEW_OWNED_THIRD_PARTY_REQUESTS
                      ) && (
                        <Tooltip
                          content={
                            <>
                              You must be the sponsor of
                              <br />
                              an assessment to renew it.
                            </>
                          }
                          position={Position.BOTTOM}
                        >
                          <PlainButton display="flex" type="submit" disabled>
                            RENEW
                            {isSubmitting && (
                              <span style={{ marginLeft: '1rem' }}>
                                <Loading size={20} />
                              </span>
                            )}
                          </PlainButton>
                        </Tooltip>
                      )
                    )}
                  </div>
                </HeaderFlexRow>
                <P>
                  <span style={{ color: colors.red }}>Important: </span>Once all
                  boxes are checked, you may renew the Third Party. If the
                  pre-screen answers need to be updated for this renewal, click
                  Unfit for Renewal and submit a new request with the updated
                  information.
                </P>
                <Wrapper>
                  <RenewalStep
                    appUser={this.props.appUser}
                    title="Third Party Information"
                    question="Does this Third Party still conduct business with the University of Rochester?"
                    content={
                      <VendorInfo
                        request={vendorRequest}
                        loaded={loaded}
                        vendorsLoaded={this.props.vendorsLoaded}
                        contacts={this.props.vendorUsers}
                        selected={values.vendorContact}
                        setContactValue={setFieldValue}
                        appUser={this.props.appUser}
                        fetchContacts={this.getChildUsers}
                      />
                    }
                    checked={values.checked1}
                    checkName="checked1"
                    handleChange={handleChange}
                    addContact={this.addNewContact}
                    setFieldValue={setFieldValue}
                  />
                </Wrapper>
                <Wrapper>
                  <RenewalStep
                    title="Pre-Screen Information"
                    question="Are these pre-screen questions and answers still valid?"
                    checked={values.checked2}
                    checkName="checked2"
                    handleChange={handleChange}
                    content={<PrescreenInfo instance={this.props.instance} />}
                  />
                </Wrapper>
                <Wrapper>
                  <RenewalStep
                    title="Sponsor Information"
                    question="Is this still the correct sponsor contact?"
                    content={
                      <SponsorInfo request={vendorRequest} loaded={loaded} />
                    }
                    checked={values.checked3}
                    checkName="checked3"
                    handleChange={handleChange}
                  />
                </Wrapper>
                <DialogWrapper
                  isOpen={this.state.dialogOpen}
                  onClose={() => this.setState({ dialogOpen: false })}
                  title="Deactivate Assessment"
                  body="If the Third Party Assessment is unfit for renewal, you can deactivate the assessment. Are you sure you want to proceed?"
                  confirm="DEACTIVATE"
                  action={this.setOutdatedStatus}
                />
              </Form>
            )}
          </Formik>
        </Container>
      );
    }
  }
}

const Wrapper = styled.div`
  width: 100%;
  padding: 0.5rem 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const StepBox = styled.div`
  width: 100%;
  border-radius: 3px;
  border: 1px solid ${colors.lightestGray};

  h1 {
    margin: 0;
    padding: 1rem;
    font-size: 1rem;
  }
`;

const StepBoxBottomBar = styled.div`
  background-color: ${colors.whiteGray};
  display: flex;
  align-items: center;
  border-top: 1px solid ${colors.lightestGray};

  h2 {
    margin: 0;
    padding: 1rem 0;
    font-size: 1rem;
    font-weight: 400;
  }
  label {
    margin-bottom: 0;
    margin-left: 1rem;
  }
`;

const P = styled.div`
  margin-top: 1rem;
  padding-left: 1rem;
  font-size: 0.9rem;
  color: ${colors.gray};
`;

const StyledContactButton = styled.span`
  button {
    background: none !important;
    color: ${colors.primary} !important;
    border: none !important;
    box-shadow: none !important;
    text-transform: uppercase;
    margin-right: 1rem;
  }
`;

const mapStateToProps = state => ({
  vendorRequest: state.vendorRequest.singleRequest,
  loaded: state.vendorRequest.requestLoaded,
  loading: state.vendorRequest.requestLoading,
  error: state.vendorRequest.requestError,
  vendorsLoaded: state.users.vendorsLoaded,
  vendorUsers: state.users.vendorUsers,
  instance: state.prescreen.instance,
  statuses: state.utils.requestStatus,
});

RenewalDetails = withRouter(
  connect(
    mapStateToProps,
    {
      fetchChildUsers,
      fetchPrescreenInstance,
      fetchAllRequestStatus,
      ...actions,
    }
  )(RenewalDetails)
);

export default RenewalDetails;
